import Util from './Util';

export default class Pager {
  constructor(args = {}) {
    this.store = args.store;
    this.node = document.querySelector('[data-role="jalan-pager"]');

    document.querySelector('body').addEventListener('click', (e) => {
      if (e.target.dataset.role === 'jalan-pager-normal-item') {
        const pageNum = Number(e.target.dataset.pagenum);
        location.href = `${location.origin}${location.pathname}?${this.getQueryWithNewDisplayFromParam(pageNum)}`;
      }
    });
  }

  getQueryWithNewDisplayFromParam(num) {
    const queryHash = Util.getUrlQueryAsHash();
    const theDisplayFrom = Number(this.store.itemSizePerPage) * (num - 1) + 1;
    queryHash.displayFrom = theDisplayFrom;
    return Util.getQueryStrFromHash(queryHash);
  }

  render() {
    const allItemSize = this.store.fetchData.numberOfResults;
    const pagerItemLength = Math.ceil(allItemSize / this.store.itemSizePerPage);
    const crPageNum = Math.floor(this.store.fetchData.displayFrom / this.store.itemSizePerPage) + 1;

    let tags = '';
    for (let i = 1; i <= pagerItemLength; i += 1) {
      if (i === crPageNum) {
        tags += `<span data-pagenum="${i}" data-role="jalan-pager-cr-item" class="page current">${i}</span>`;
      } else {
        tags += `<span class="page"><a data-pagenum="${i}" data-role="jalan-pager-normal-item">${i}</a></span>`;
      }
    }
    this.node.innerHTML = tags;
  }
}
